import React from "react";
import AppButton from "../../components/app-button/AppButton";
import { Box, Button } from "@mui/material";
import InvoicePrint from "./InvoicePrint";
import ReactDOMServer from "react-dom/server";

const TestPrint = () => {
  const settings = { printQRCode: true };
  const order = {
    storeName: "My Cafe",
    storeAddress: "123 Street, City",
    invoiceNo: "INV-1001",
    date: "2025-09-15",
    cashier: "Raj",
    items: [
      { id: 1, name: "Coffee", qty: 2, amount: "₹100" },
      { id: 2, name: "Sandwich", qty: 1, amount: "₹80" },
    ],
    total: "₹180",
  };

  const handleTestPrint = () => {
    // 1️⃣ Render InvoicePrint component to static HTML string
    const invoiceHtml = ReactDOMServer.renderToStaticMarkup(
      <InvoicePrint order={order} settings={settings} />
    );

    // 2️⃣ Open new print window
    const printWindow = window.open("", "_blank", "width=400,height=600");

    // 3️⃣ Write HTML with auto-print & auto-close
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice Print</title>
          <style>
            body { margin: 0; padding: 10px; font-family: monospace; font-size: 12px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${invoiceHtml}
        </body>
      </html>
    `);
    // printWindow.document.close();
  };

  //   const handleTestPrint = () => {
  //     const printContent = `
  //       <div style="font-family: monospace; width: 280px; padding: 10px;">
  //         <div style="text-align: center;">
  //           <strong>⭐ Sana Bar & Cafe ⭐</strong><br/>
  //           123 Main Street, City<br/>
  //           +91-9876543210
  //         </div>
  //         <hr/>
  //         <div style="text-align: center; font-size: 14px;">
  //           <strong>TEST PRINT RECEIPT</strong>
  //         </div>
  //         <hr/>
  //         <div style="font-size: 12px;">
  //           Date: ${new Date().toLocaleDateString()}
  //           Time: ${new Date().toLocaleTimeString()}<br/>
  //           Cashier: Rajendra<br/>
  //           Table: T1 | Guests: 2<br/>
  //           Order No: 000123
  //         </div>
  //         <hr/>
  //         <table style="width: 100%; font-size: 12px;">
  //           <tr>
  //             <td>Coffee</td><td style="text-align:right;">2</td><td style="text-align:right;">100.00</td>
  //           </tr>
  //           <tr>
  //             <td>Sandwich</td><td style="text-align:right;">1</td><td style="text-align:right;">150.00</td>
  //           </tr>
  //           <tr>
  //             <td>Fries</td><td style="text-align:right;">1</td><td style="text-align:right;">80.00</td>
  //           </tr>
  //         </table>
  //         <hr/>
  //         <table style="width: 100%; font-size: 12px;">
  //           <tr>
  //             <td>Subtotal</td><td style="text-align:right;">330.00</td>
  //           </tr>
  //           <tr>
  //             <td>GST (5%)</td><td style="text-align:right;">16.50</td>
  //           </tr>
  //           <tr>
  //             <td><strong>TOTAL</strong></td>
  //             <td style="text-align:right;"><strong>346.50</strong></td>
  //           </tr>
  //         </table>
  //         <hr/>
  //         <div style="text-align:center; font-size: 12px;">
  //           Thank you for visiting us!<br/>
  //           www.sanabarcafe.com
  //         </div>
  //       </div>
  //     `;

  //     const printWindow = window.open("", "_blank", "width=400,height=600");
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head><title>Test Print</title></head>
  //         <body onload="window.print(); window.close();">
  //           ${printContent}
  //         </body>
  //       </html>
  //     `);
  //     // printWindow.document.close();
  //   };

  return (
    <Box>
      <AppButton onClick={handleTestPrint}>
        Test Print
      </AppButton>
    </Box>
  );
};

export default TestPrint;
